import { useSharedKey } from '@/shared/hooks/use-shared-key';
import { getBotId } from '../api/api';

/**
 * Reactive current bot id, sourced the same way `getBotId()` is (shared
 * state, falling back to localStorage for standalone dev) but re-rendering on
 * a bot switch.
 *
 * `getBotId()` alone is correct for one-shot reads (request headers, mutation
 * payloads) since it's called fresh per invocation — but a value bound to it
 * at render time would go stale for the lifetime of the component. Feed this
 * into a query key so bot-scoped data refetches on a bot switch instead of
 * serving the previous bot's cache.
 */
export function useCurrentBotId(): string {
  return useSharedKey('bots', getBotId);
}
